"use client";

import { createContext } from "react";

import type { NodeDefinition } from "@/generated";
import type { GraphNodeV2 } from "@/types/spotflow-v2";

/**
 * Editor-shaped nodes rebuilt from a run's stored workflow definition.
 *
 * The V2 bindings hooks read the editor atoms (`nodesAtom`/`nodeRegistryAtom`),
 * which are only hydrated while the flow editor is mounted. Run viewers outside
 * the editor (e.g. the case view's run modal) provide this context so
 * "Variables used" can resolve against the definition the run actually
 * executed instead of rendering empty.
 */
export interface RunDefinitionFallback {
  nodes: GraphNodeV2[];
  registry: NodeDefinition[];
}

export const RunDefinitionFallbackContext =
  createContext<RunDefinitionFallback>({ nodes: [], registry: [] });
